import type { ReactNode } from "react";
import Reveal from "@/components/ui/Reveal";

type PageHeroProps = {
  eyebrow: string;
  title: ReactNode;
  description: ReactNode;
  /** Optional content under the description, e.g. CTAs or a notice. */
  children?: ReactNode;
};

/**
 * The opening band for the inner marketing pages (/product, /solutions, /how-it-works,
 * /faqs, /about): the same white background and eyebrow-and-rule heading as the home hero,
 * without its slideshow or scroll pin.
 */
export default function PageHero({ eyebrow, title, description, children }: PageHeroProps) {
  return (
    <section className="bg-white px-margin-mobile md:px-margin-desktop pt-size-xl pb-size-lg">
      <Reveal className="max-w-[1440px] mx-auto">
        <div className="max-w-4xl">
          <div className="flex items-center gap-base mb-size-sm">
            <span className="w-12 h-[1px] bg-mkt-primary" />
            <span className="font-label-md text-label-md text-mkt-primary uppercase tracking-widest">{eyebrow}</span>
          </div>
          <h1 className="font-display-lg text-[clamp(32px,4.4vw,64px)] leading-[1.1] tracking-[-0.02em] font-bold text-mkt-inarax-black text-balance">
            {title}
          </h1>
          <p className="mt-size-md font-body-lg text-body-lg text-mkt-on-surface-variant max-w-3xl">{description}</p>
          {children}
        </div>
      </Reveal>
    </section>
  );
}
